import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '@app/public/header/header.component';
import { FooterComponent } from '@app/public/footer/footer.component';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent],
  template: `
    <app-header></app-header>
    <main class="about-page">
      <div class="container">
        <h1 class="about-title">À PROPOS DE NOUS</h1>
        <h2 class="about-subtitle">
          NOUS LUTTONS CONTRE LE GASPILLAGE ALIMENTAIRE ENSEMBLE
        </h2>
        <p class="about-mission">
          Zero Waste est une entreprise à impact social, dont la mission est
          d'inspirer et de donner à chacun les moyens de lutter ensemble contre
          le gaspillage alimentaire.
        </p>

        <div class="about-vision">
          <img
            src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80"
            alt="Vision Zero Waste"
          />
          <p class="about-vision-text">
            Nous rêvons d'une planète<br />
            <b>sans gaspillage alimentaire</b>
          </p>
        </div>

        <section class="about-history">
          <h3>DÉCOUVRIR<br />NOTRE HISTOIRE</h3>
          <p>
            Zero waste a été co-fondée par deux jeunes entrepreneurs Tunisien,
            pour lutter contre le gaspillage alimentaire. Ils avaient pour
            ambition de trouver une solution pour permettre aux commerçants de
            réduire la quantité de nourriture qui était gaspillée
          </p>
        </section>

        <section class="about-impact">
          <h3>AVOIR UN IMPACT POSITIF</h3>
          <h4>
            NOS CRITÈRES ENVIRONNEMENTAUX, SOCIAUX ET DE GOUVERNANCE (ESG)
          </h4>
          <p>
            Chez Zero waste, l'ESG a pour objectif que nos actions, en
            complément des solutions de réduction du gaspillage alimentaire,
            aient un impact positif.<br /><br />
            Pour accompagner une prise de conscience du gaspillage alimentaire
            et la mise en place d'actions concrètes, nous lançons plusieurs
            démarches. Nous nous engageons dans des initiatives règlementaires,
            nous lançons des initiatives auprès des ménages pour aider à la
            réduction des déchets (alimentaires), et nous lançons des programmes
            d'éducation pour inspirer les futures générations.
          </p>
        </section>

        <section class="about-region">
          <h3>EST-CE QUE ZERO WASTE SE TROUVE DANS MA RÉGION ?</h3>
          <h4>UN IMPACT POSITIF DANS LE MONDE ENTIER</h4>
          <p>
            Chez ZERO WASTE, nous continuons à nous développer rapidement, en
            élargissant notre impact dans le monde entier. Aujourd'hui, ZERO
            WASTE est présent dans la Grande Tunisie seuelement.
          </p>
        </section>

        <section class="about-team">
          <h3>NOTRE ÉQUIPE DE direction</h3>
          <h4>L'ÉQUIPE DE MANAGEMENT DE ZERO WASTE</h4>
          <div class="team-avatars">
            <div class="team-member">
              <img
                src="/assets/img/team/mohamed-oussema-njimi.jpg"
                alt="Mohamed Oussema Njimi"
              />
              <div class="team-name">Mohamed Oussema Njimi</div>
              <div class="team-role">CEO</div>
            </div>
            <div class="team-member">
              <img src="/assets/img/team/ahmed-zayati.jpg" alt="Ahmed Zayati" />
              <div class="team-name">Ahmed Zayati</div>
              <div class="team-role">CTO</div>
            </div>
          </div>
        </section>
      </div>
    </main>
    <app-footer></app-footer>
  `,
  styles: [
    `
      .about-page {
        padding: 80px 0 40px;
        background: #f9f9f9;
      }
      .container {
        max-width: 900px;
        margin: 0 auto;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        padding: 40px 24px;
      }
      .about-title {
        text-align: center;
        color: var(--primary-color, #00615f);
        font-size: 2.2rem;
        margin-bottom: 10px;
      }
      .about-subtitle {
        text-align: center;
        color: #222;
        font-size: 1.3rem;
        margin-bottom: 24px;
      }
      .about-mission {
        text-align: center;
        font-size: 1.1rem;
        margin-bottom: 32px;
      }
      .about-vision {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;
      }
      .about-vision img {
        width: 220px;
        height: 220px;
        object-fit: cover;
        border-radius: 50%;
        box-shadow: 0 4px 16px rgba(0, 97, 95, 0.08);
        margin-bottom: 18px;
      }
      .about-vision-text {
        text-align: center;
        font-size: 1.2rem;
        font-weight: 500;
        color: #00615f;
      }
      .about-history,
      .about-impact,
      .about-region,
      .about-team {
        margin-bottom: 36px;
      }
      .about-history h3,
      .about-impact h3,
      .about-region h3,
      .about-team h3 {
        color: var(--primary-color, #00615f);
        font-size: 1.2rem;
        margin-bottom: 10px;
        text-transform: uppercase;
      }
      .about-impact h4,
      .about-region h4,
      .about-team h4 {
        color: #333;
        font-size: 1.05rem;
        margin-bottom: 8px;
        font-weight: 600;
      }
      .about-history p,
      .about-impact p,
      .about-region p {
        font-size: 1rem;
        color: #444;
        margin-bottom: 0;
      }
      .about-team .team-avatars {
        display: flex;
        gap: 40px;
        justify-content: center;
        margin-top: 24px;
      }
      .team-member {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .team-member img {
        width: 110px;
        height: 110px;
        border-radius: 50%;
        margin-bottom: 10px;
        box-shadow: 0 2px 8px rgba(0, 97, 95, 0.1);
      }
      .team-name {
        font-weight: 700;
        color: #222;
        margin-bottom: 2px;
      }
      .team-role {
        color: #00615f;
        font-size: 0.98rem;
        font-weight: 500;
      }
      @media (max-width: 600px) {
        .container {
          padding: 18px 4px;
        }
        .about-team .team-avatars {
          flex-direction: column;
          gap: 18px;
        }
      }
    `,
  ],
})
export class AboutUsComponent {}
